// Hằng số vùng ký trên PDF biên bản thỏa thuận.
// Cấu trúc bám theo sign_zones của hệ e-sign (gui-esign) để backend tái dùng parser.
import { TYPE_REPORT_WORD } from "constants/IssueInvoiceConstant";

export const SIGN_PARTY = {
  A: "PARTY_A",
  B: "PARTY_B",
};

// Màu viền khung ký trên PDF. Bên B dùng vàng theo quy ước "đối tác" của e-sign.
export const SIGN_ZONE_COLOR = {
  [SIGN_PARTY.A]: "#ff0000",
  [SIGN_PARTY.B]: "#FFC107",
};

// Lệnh mà panel phát ra cho viewer chuyển thành postMessage sang iframe pdf.js
export const SIGN_ZONE_ACTION = {
  CREATE: "CREATE_SIGN_ZONE",
  VIEW: "VIEW_SIGN_ZONE",
  DELETE: "DELETE_SIGN_ZONE",
};

// Đường dẫn tương đối tới viewer pdf.js đã copy vào public/
export const PDFJS_VIEWER_PATH = "/pdfjs-4.3.136-dist/web/viewer.html";

const ACTIVITY_SIGN_DIGITAL = { value: "SIGN_DIGITAL", label: "Ký số" };

// Vị trí khung ký mặc định — ngay dưới "ĐẠI DIỆN BÊN A" của mẫu biên bản.
// Toạ độ theo hệ canvas của pdf.js (đơn vị pixel ở mức zoom lúc vẽ), zone_page
// đếm từ 0. Mỗi loại biên bản có bố cục khác nhau nên chỗ ký cũng khác.
const SIGN_ZONE_SIZE = {
  zone_width: 195.1067961165047,
  zone_height: 65.20783896775356,
};

// Điều chỉnh / thay thế: chỗ ký nằm cuối trang 1 (lấy từ một lần đặt thủ công)
const SIGN_ZONE_RECT_PAGE_1 = {
  zone_page: 0,
  zone_x: 66.05825242718437,
  zone_y: 689.2790034586358,
  ...SIGN_ZONE_SIZE,
};

// Điều chỉnh thông tin khách hàng: nội dung dài hơn nên "ĐẠI DIỆN BÊN A" rơi
// sang đầu trang 2. zone_y ước lượng theo bản xem trước, lệch thì chỉnh ở đây.
const SIGN_ZONE_RECT_INFO = {
  zone_page: 1,
  zone_x: 40.05825242718437,
  zone_y: 200,
  ...SIGN_ZONE_SIZE,
};

export const SIGN_ZONE_DEFAULT_RECT = {
  [TYPE_REPORT_WORD.ADJUST]: SIGN_ZONE_RECT_PAGE_1,
  [TYPE_REPORT_WORD.CANCEL]: SIGN_ZONE_RECT_PAGE_1,
  [TYPE_REPORT_WORD.INFO]: SIGN_ZONE_RECT_INFO,
  // Biên bản thay thế điều chỉnh thông tin (MTT) in ra cùng bố cục với INFO
  [TYPE_REPORT_WORD.INFO_CANCEL]: SIGN_ZONE_RECT_INFO,
};

/** Vị trí khung ký mặc định theo loại biên bản; loại chưa khai báo dùng trang 1 */
export const getSignZoneDefaultRect = typeReport =>
  SIGN_ZONE_DEFAULT_RECT[typeReport] || SIGN_ZONE_RECT_PAGE_1;

// Cấu hình khung ký mặc định: 170x50 điểm, lấy theo cấu hình "Ký số cá nhân" của e-sign
const DATA_SIGN_DIGITAL = {
  is_sign_digital: true,
  sign_digital_width: 170,
  sign_digital_height: 50,
};

// TODO: thay bằng sign_zones do API agreement-info trả về khi backend sẵn sàng
export const SIGN_ZONE_INIT = [
  {
    id: SIGN_PARTY.A,
    node_name: "Bên A (bên mua)",
    node_code: SIGN_PARTY.A,
    n_action_code: SIGN_PARTY.A,
    n_action_name: "Ký số / Digital Signature",
    n_action_activity: [{ ...ACTIVITY_SIGN_DIGITAL }],
    activity: { ...ACTIVITY_SIGN_DIGITAL },
    // Để rỗng: panel sẽ tự tạo vùng ký mặc định sau khi PDF nạp xong, đi qua
    // đúng luồng "Thêm vùng ký" nên khung được vẽ thật trên PDF
    zone_infos: [],
    data: { ...DATA_SIGN_DIGITAL },
    user_signature_config: "BY_PERSONAL",
  },
  // {
  //   id: SIGN_PARTY.B,
  //   node_name: "Bên B (bên mua)",
  //   node_code: SIGN_PARTY.B,
  //   n_action_code: SIGN_PARTY.B,
  //   n_action_name: "Ký số / Digital Signature",
  //   n_action_activity: [{ ...ACTIVITY_SIGN_DIGITAL }],
  //   activity: { ...ACTIVITY_SIGN_DIGITAL },
  //   zone_infos: [],
  //   data: { ...DATA_SIGN_DIGITAL },
  //   user_signature_config: "BY_PERSONAL",
  // },
];
